import React from "react";
import HeroCard from "@/components/heroCard";
import { CONCLUSION_CONSTANTS } from "./constants";

const ContactCta = () => {
  return (
    <HeroCard backgroundImage="/bare-metal/pricingConc.png" {...CONCLUSION_CONSTANTS} />
  );
};

export default ContactCta;
